module.exports = (fox) => {
  const $ = fox.jQuery;
  const _ = {
    getTranslation: function (alias) {
      var translation = {
        somethingWentWrong: fox.i18n.getTranslation(
          "somethingWentWrong",
          "Something went wrong",
          "notifications"
        ),
      };
      return translation[alias] || "";
    },
  };

  const MC_PROFITS_AREA = "MCPROFITS_AREA";

  const MC_FIELDS = [
    "items.alias",
    "items.actionInfo",
    "items._actionInfo",
    "title",
    "id",
    "items.project",
    "items(modelcentro)",
  ];

  const FC_FIELDS = [
    "items.alias",
    "items.actionInfo",
    "items._actionInfo",
    "title",
    "id",
    "items.project",
    "items(fancentro)",
  ];

  fox.registerWidget("Affiliate_LinkGeneration", {
    configure() {
      require("script!clipboard/dist/clipboard.js");

      this.registerOptions("", {
        template: "popup_affiliate_linkGeneration",
        autoRender: true,
        templateOptions: {
          id: this._id,
        },
        widgets: {
          programsListDl: {
            widget: "Datalayer",
            method: "affiliate.program.getList",
          },
          generateCodeApi: {
            widget: "Api",
            method: "PromoContent.generateCode",
            httpMethod: "post",
          },
          programsList: {
            widget: "Widget",
            manualRender: true,
            template: "popup_affiliate_linkGeneration_programs",
            container: ".programs-list-wrapper",
          },
          generateCodeBlock: {
            widget: "Widget",
            autoRender: false,
            container: ".generated-link-container",
            template: "popup_affiliate_banners_linkGeneration_action",
            "handleWom.addedToDom": {
              event: "addedToDom",
              widget: "@this",
              callback: "@parent:_attachClipboardAction",
            },
          },
          discountBlock: {
            widget: "Widget",
            manualRender: true,
            container: ".discount-section",
            template: "popup_affiliate_linkGeneration_discount",
            "widgets.periodSelector": {
              widget: "PeriodSelector",
              allowSameDates: true,
              newSelect: true,
              "widgets.dateFrom.initialDate": new Date(),
              "widgets.dateTo.initialDate": "+1m",
            },
            handleDom: {
              discountToggle: {
                target: ".discount-toggle",
                event: "click",
                callback: "@parent:_discountToggle",
              },
              permanentToggle: {
                target: ".permanent-toggle",
                event: "click",
                callback: "@parent:_permanentToggle",
              },
              focus: {
                target: 'input[type="text"]',
                event: "focus",
                callback: "@parent:hideError",
              },
              focusCalendar: {
                target: "#period-selector",
                event: "click",
                callback: "@parent:hideError",
              },
            },
          },
        },
        handleDom: {
          selectProgram: {
            targetWidget: "#programsList",
            target: "select[name]",
            event: "change",
            callback: "_handleSelectChange",
          },
          generateCode: {
            targetWidget: "#generateCodeBlock",
            target: ".generate-code",
            event: "click",
            callback: "_generateCode",
          },
          focus: {
            target: 'input[type="text"]',
            event: "focus",
            callback: "hideError",
          },
        },

        handleWom: {
          addedToDom: {
            widget: "@this",
            event: "addedToDom",
            callback: function (params, _this) {
              var parentId = _this._id;
              var taggle = (this.taggle = new Taggle(
                "trafficTags-" + parentId,
                {
                  placeholder: ["Add traffic tags, separated by comma"],
                  submitKeys: [188, 9, 13],
                  tabIndex: [3],
                  saveOnBlur: true,
                }
              ));

              this.unlockFields();

              if ($(_this.element).tooltip("instance") === undefined) {
                $(_this.element).tooltip({
                  position: {
                    my: "left-20% bottom-15",
                    at: "bottom left",
                    collision: "flipfit",
                  },
                  tooltipClass: "gui-tooltip-type-1 bottom",
                  items: ".gui-tooltip-link",
                  content: function () {
                    return $(this).find(".tt-content").html();
                  },
                  hide: { delay: 1000 },
                });
              }
            },
          },
        },
      });

      this.callParent("configure", arguments);
    },

    init: function () {
      this.popup = this.wom1("@parent");
      this.notifications = fox.wom.selectFirst("~#throughNotifications");

      this.callParent("init", arguments);
    },

    running: function () {
      this.callParent("running", arguments);

      this.programsDl = this.wom1("#programsListDl");
      this.programsList = this.wom1("#programsList");
      this.generateCodeApi = this.wom1("#generateCodeApi");
      this.generateCodeBlock = this.wom1("#generateCodeBlock");
      this.discountBlock = this.wom1("#discountBlock");
      this.periodSelector = this.discountBlock.wom1("#periodSelector");

      this._reset();

      this.handleEvent(this.popup, "hide", "_reset");
    },

    activate: function () {
      //this.taggle.enable();
      this.callParent("activate", arguments);
    },

    deactivate: function () {
      delete this.cp;
      delete this.cpr;

      this.taggle.disable();
      this.unlockFields();

      this.callParent("deactivate", arguments);
    },

    reset: function () {
      this.ownerId = null;
      this.project = null;
      this.programId = null;
      this.campaignId = null;
      this.generatedCode = null;
    },

    _reset: function () {
      this.reset();
      this.render();

      this.generateCodeBlock.setTemplateOptions("embedCode", null);
      if (this.getRefCodeLink() !== false) {
        this.generateCodeBlock.setTemplateOptions("refCodeLink", null);
      }
      this.generateCodeBlock.setTemplateOptions(
        "buttonTitle",
        this.getOption("buttonTitle")
      );
      this.generateCodeBlock.render();
      if (
        fox.getEnv("public.area.title") === MC_PROFITS_AREA &&
        this.project &&
        this.project !== 4
      ) {
        this.discountBlock.render();
      }
    },

    setOwnerId: function (id) {
      this.ownerId = id;

      return this.loadOwnerPrograms();
    },

    setItemProject: function (id) {
      this.project = id;
    },

    loadOwnerPrograms: function () {
      var itemProject = parseInt(this.project);
      this.programsDl.setTransitParameter("ownerId", this.ownerId);
      itemProject === 1
        ? this.programsDl.setFields(MC_FIELDS)
        : this.programsDl.setFields(FC_FIELDS);

      return this.loadPrograms().then(() => this._handleProgramsDlResponse());
    },

    loadPrograms: function () {
      return new fox.Promise((resolve) => this.programsDl.load().then(resolve));
    },

    _handleProgramsDlResponse: function () {
      var c = this.programsDl.getCollection();
      var itemProject = parseInt(this.project);

      this.renderProgramsSelect(c, itemProject);
      if (
        itemProject !== 4 &&
        fox.getEnv("public.area.title") === MC_PROFITS_AREA
      ) {
        this.discountBlock.render();
      }
    },

    renderProgramsSelect: function (collection) {
      var opts = [{ id: -1, title: "Select program", hidden: true }];

      if (fox.count(collection) === 1) {
        var item = collection[0];
        this.programsList.setTemplateOptions({
          single: true,
          title: item.title,
        });
        this.programsList.render();

        this.programId = item.id;

        return;
      }

      fox.each(collection, function (item) {
        opts.push({ id: item.id, title: item.title });
      });

      this.programsList.setTemplateOptions({ programs: opts });
      this.programsList.render();
    },

    _handleSelectChange: function (el, alias, w, e) {
      var option = el.options[el.selectedIndex];
      var selectedElm = fox.dom.selectFirst(".select-value", el.parentNode);

      fox.dom.selectFirst("p", selectedElm).innerHTML = option.innerHTML;
      fox.dom.addClass("selected", selectedElm);

      if (alias === "selectProgram") {
        this.programId = option.value;
        this.hideError(".programs-list-select");

        return;
      }
    },

    getSelectValue: function (wAlias) {
      var select = this.wom1("#" + wAlias).dom1("select[name]");

      return select.options[select.selectedIndex].value;
    },

    _generateCode: function () {
      var params = {};
      params.discountParams = {};
      params.programId = this.programId;
      this.campaignId = null;
      params.title = this.dom1('input[name="newCampaignName"]').value;

      if (!!this.packageId) {
        params.id = this.packageId;
      }
      if (!!this.campaignId) {
        params.campaignId = this.campaignId;
      }

      if (fox.getEnv("isWLArea") === true) {
        params.modelId = this.ownerId;
      }

      var tags = this.taggle.getTagValues();
      params.trafficTags = tags.join(",");

      var discountElt = this.dom1('input[name="discountEnabled"]');
      this.discountEnabled = discountElt && discountElt.checked;
      if (this.discountEnabled) {
        params.discountParams.discount = this.dom1(
          'input[name="discount"]'
        ).value;
        params.discountParams.permanent = Number(
          this.dom1('input[name="permanent"]').checked
        );
        params.discountParams.stateAlias = "active";
        if (!params.discountParams.permanent) {
          var dateFromTo = this.periodSelector.getParamsForApi();
          params.discountParams.validFrom =
            fox.utils.resolveDate(dateFromTo.dateFrom).getTime() / 1000;
          params.discountParams.validTill =
            fox.utils.resolveDate(dateFromTo.dateTo).getTime() / 1000 +
            (24 * 60 * 60 - 1);
        }
      }

      this.generateCode(params);
    },

    generateCode: function (params) {
      if (this.isValid(params)) {
        this.lockFields();
        this.generateCodeApi
          .psend(params)
          .then(
            function (resp) {
              this._handleGenerateAPiResponse(resp.params);
            }.bind(this)
          )
          .catch(
            function (err) {
              this.unlockFields();
              console.error("catch", err);
            }.bind(this)
          );
      }
    },

    isValid: function (params) {
      var result = true;

      if (!params.programId) {
        result = false;
        this.showError(".programs-list-select");
      }

      if (!params.campaignId && !params.title) {
        result = false;
        this.showError('[name="newCampaignName"]', "This field is required");
      }

      if (this.discountEnabled) {
        if (fox.isEmpty(params.discountParams.discount)) {
          result = false;
          this.showError('[name="discount"]', "This field is required");
        } else if (!fox.isNumeric(params.discountParams.discount)) {
          result = false;
          this.showError('[name="discount"]', "Only numbers allowed");
        } else if (
          params.discountParams.discount < 1 ||
          params.discountParams.discount > 45
        ) {
          result = false;
          this.showError(
            '[name="discount"]',
            "Should be between 1 and 45 percents"
          );
        }
        if (params.discountParams.validFrom > params.discountParams.validTill) {
          result = false;
          this.showError("#period-selector", "Incorrect date range");
        }

        var fullDate = new Date();
        var zeroDate =
          new Date(
            fullDate.getFullYear(),
            fullDate.getMonth(),
            fullDate.getDate()
          ) / 1000;
        if (
          params.discountParams.validFrom < zeroDate ||
          params.discountParams.validTo < zeroDate
        ) {
          result = false;
          this.showError("#period-selector", "You’ve specified expired dates");
        }
      }

      return result;
    },

    renderGeneratedLinkBlock: function (data) {
      var w = this.wom1("#generateCodeBlock");

      this._setCode(data);

      w.setTemplateOptions("embedCode", this.getCode());
      if (this.getRefCodeLink() /* !== false*/) {
        w.setTemplateOptions("refCodeLink", this.getRefCodeLink());
      }
      w.setTemplateOptions("buttonTitle", this.getOption("buttonTitle"));
      w.render();

      this.popup._center();
    },

    _setCode: function (data) {
      this.hookWrapper("setCode", data);
    },

    setCode: function (data) {
      this.generatedCode = data.modelLink;
    },

    getCode: function () {
      return this.generatedCode;
    },

    getRefCodeLink: function () {
      return this.generatedRefCodeLink;
    },

    _attachClipboardAction: function (params, widget) {
      var _this = this;

      if (this.cp) return false;
      if (this.cpr) return false;

      var clipboard = (this.cp = new ClipboardJS(".copy-code", {
        target: function (trigger) {
          return widget.dom1("#link-dest");
        },
      }));

      var clipboardRefCode = (this.cpr = new ClipboardJS(".copy-refcode", {
        target: function (trigger) {
          return widget.dom1("#link-dest-refCodeLink");
        },
      }));
    },

    _handleGenerateAPiResponse: function (resp, w, e) {
      if (fox.inArray(["error", "failure"], e)) {
        console.error("unhandled error", arguments);
        this.notifications.pushNotification({
          noticeAlias: "generateCodeError",
          noticeType: "error",
          noticeMessage: _.getTranslation("somethingWentWrong"),
          delayClose: 3000,
          listeWidgetDeactivate: this,
        });

        return true;
      }

      resp = resp.answer.response;

      this.renderGeneratedLinkBlock(resp);
      this.dispatchEvent("codeGenerated");
      return;
    },

    lockFields: function (argument) {
      var ttField = this.dom1(".trafficTags");
      if (ttField) {
        this.taggle.disable();
        fox.dom.addClass("disabled", ttField);
      }

      var newCampField = this.dom1('[name="newCampaignName"]');
      newCampField.disabled = true;
      fox.dom.addClass("disabled", newCampField);

      ttField = this.dom1("#trafficTags");
      if (ttField) {
        this.taggle.disable();
        fox.dom.addClass("disabled", ttField);
      }
      var discountEnabled = this.discountBlock.dom1('[name="discountEnabled"]');
      if (!!discountEnabled) {
        discountEnabled.disabled = true;
        this.discountBlock.dom1('[name="permanent"]').disabled = true;
        this.discountBlock.dom1('[name="discount"]').disabled = true;
        this.periodSelector.wom1("#dateFrom").setOption("disabled", true);
        this.periodSelector.wom1("#dateTo").setOption("disabled", true);
      }
      var generateButton = this.dom1(".generate-code");
      fox.dom.addClass("spin", generateButton);
      return true;
    },

    unlockFields: function () {
      var ttField = this.dom1(".trafficTags");
      if (ttField) {
        this.taggle.enable();
        fox.dom.removeClass("disabled", ttField);
      }

      var newCampField = this.dom1('[name="newCampaignName"]');
      newCampField.disabled = false;
      fox.dom.removeClass("disabled", newCampField);

      var discountEnabled = this.discountBlock.dom1('[name="discountEnabled"]');
      if (!!discountEnabled) {
        discountEnabled.disabled = false;
        this.dom1('[name="newCampaignName"]').disabled = false;
        this.discountBlock.dom1('[name="permanent"]').disabled = false;
        this.discountBlock.dom1('[name="discount"]').disabled = false;
        this.periodSelector.wom1("#dateFrom").setOption("disabled", false);
        this.periodSelector.wom1("#dateTo").setOption("disabled", false);
      }

      return true;
    },

    showError: function (elt, error) {
      var errorField = this.dom1(elt);
      var prevElement = errorField.previousElementSibling;

      fox.dom.addClass("error", errorField);

      if (prevElement) {
        prevElement.setAttribute("data-error", error);
      }

      return;
    },

    hideError: function (elt) {
      var errorField = this.dom1(elt);
      var prevElement = errorField.previousElementSibling;

      fox.dom.removeClass("error", errorField);

      if (prevElement) {
        prevElement.removeAttribute("data-error");
      }

      return;
    },

    _discountToggle: function () {
      $(".discount-view").toggleClass("_hidden");
    },

    _permanentToggle: function () {
      $(".permanent-view").toggleClass("_hidden");
    },
  });
};



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/popup/affiliate/linkGeneration.es.js